import type { BaseIconProps } from '@/components/ui/BaseIcon.vue';
import { useLogger } from '@/composables/useLogger';
import { LoggerLevel } from '@/constants/logLevel';
import { h, type FunctionalComponent } from 'vue';

export function mapComponentFromConfig(props: BaseIconProps, aliases: Record<string, FunctionalComponent>) {
  const iconName = typeof props.icon === 'string' ? props.icon : '';
  const component = iconName in aliases ? aliases[iconName as keyof typeof aliases] : undefined;
  if (!component) {
    const { log } = useLogger();

    log({
      type: 'warn',
      message: `Icon ${iconName} not found in config`,
      level: LoggerLevel.DEVELOPMENT

    });
  }
  return component ? h(component) : undefined;
}
